import { Attribute, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[errorAnchor]'
})
export class ErrorAnchorDirective {

  constructor(private host: ElementRef<HTMLElement>,) { }

  get element() {
    return this.host.nativeElement;
  }

}


@Directive({
  selector: 'form'
})
export class FormAnchorDirective {

  constructor(private host: ElementRef<HTMLElement>,
    @Attribute("formName") private name: string, @Attribute("parentForm") private parentFormRequired :  string ) { }

  get element() {
    return this.host.nativeElement;
  }

  get formName() {
    return this.name
  }

  get isParentForm(){
    return this.parentFormRequired === null ? true : false
  }

}
